import React, { Component } from 'react'
import Tux from '../../images/linux-logo.svg'
import Coffee from '../../images/coffee-cup.svg'

export default class Footer extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { info: data } = this.props
    return (
      <footer>
        <section className="social-networks">
          <ul>
            <li>
              <a
                href="http://phanorcoll.deviantart.com/"
                className="a-animation"
              >
                deviantart
              </a>
            </li>
            <li>
              <a href="https://twitter.com/phanor/" className="a-animation">
                twitter
              </a>
            </li>
            <li>
              <a href="https://github.com/phanorcoll" className="a-animation">
                github
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/phanorcoll/"
                className="a-animation"
              >
                linkedin
              </a>
            </li>
          </ul>
          <div className="copyright">
            <div>
              © 2018 &nbsp;
              <a href="https://twitter.com/phanor" className="a-animation">
                <strong>{data.site.siteMetadata.author}</strong>
              </a>. All Rights Reserved.
            </div>
            <div>
              Made with lots of
              <img src={Coffee} alt={data.site.siteMetadata.author} /> on
              <img src={Tux} alt={data.site.siteMetadata.author} /> using &nbsp;
              <a href="https://www.gatsbyjs.org/" className="a-animation">
                <strong>Gatsbyjs</strong>
              </a>
            </div>
          </div>
        </section>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx